import GradeDropdown from "../CustomDropdown/CustomDropdown";
import "./AdminStyles.scss";

// Two-row layout: heading on row 1, grade pill (left) + time filter (right) on row 2
const tabRequireGradeDropdown = ["CLASSROOM_VIEW", "TEACHER_VIEW", "STUDENT_VIEW"];

// Single-row layout: heading left, "For class: X" dropdown right
const tabRequireInlineGradeDropdown = ["TROO_STORIES", "ACTIVITIES"];

type Props = {
  selectedStudent: any;
  onStudentChange: (val: any) => void;
  timeRange: string;
  onTimeChange: (val: any) => void;
  search: string;
  onSearch: (val: string) => void;
  tab: string;
  students: any[];
  grades?: any[];
  grade?: string;
  onGradeChange?: (val: string) => void;
};

const TIME_FILTERS = [
  { label: "7 days", value: "Weekly" },
  { label: "30 days", value: "Monthly" },
];

const tabRequireTimeFilter = ['CLASSROOM_VIEW', 'TEACHER_VIEW', "STUDENT_VIEW", "SCHOOL_VIEW"];

const headingName = {
  'SCHOOL_VIEW': 'School Insights',
  'CLASSROOM_VIEW': 'Classroom Insights',
  'TEACHER_VIEW': 'Teacher Insights',
  'STUDENT_VIEW': 'Student Insights',
  'RESOURCES': 'Resources',
  'TROO_STORIES': 'Troo Stories',
  'ACTIVITIES': 'Activities',
};

const AdminSubHeader = ({
  timeRange,
  onTimeChange,
  search,
  onSearch,
  tab,
  onStudentChange,
  selectedStudent,
  students,
  grades,
  grade,
  onGradeChange,
}: Props) => {
  const heading = headingName[tab as keyof typeof headingName];
  const showGradePill = tabRequireGradeDropdown.includes(tab) && grades && grades.length > 0;
  const showInlineGrade = tabRequireInlineGradeDropdown.includes(tab) && grades && grades.length > 0;
  const showTimeFilter = tabRequireTimeFilter.includes(tab);
  const showSecondRow = showGradePill || tab === "STUDENT_VIEW" || showTimeFilter;

  // Single-row layout for TROO_STORIES / ACTIVITIES
  if (showInlineGrade) {
    return (
      <div className="dashboard-headers dashboard-headers--inline">
        {heading && <div className="subheader">{heading}</div>}
        <div className="subheader-for-class">
          <span className="for-class-label">For class:</span>
          <GradeDropdown
            grades={grades}
            value={grade}
            onChange={onGradeChange}
          />
        </div>
      </div>
    );
  }

  // Two-row layout for insight tabs
  return (
    <div className="dashboard-headers">
      {heading && <div className="subheader">{heading}</div>}

      {showSecondRow && (
        <div className="subheader-row">
          <div className="subheader-left">
            {showGradePill && (
              <GradeDropdown
                grades={grades}
                value={grade}
                onChange={onGradeChange}
              />
            )}
            {tab === "STUDENT_VIEW" && (
              <select
                value={selectedStudent?.id || ""}
                onChange={(e) => {
                  const student = students?.find(
                    (s) => String(s.id) === e.target.value,
                  );
                  onStudentChange(student || null);
                }}
              >
                {students?.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s?.name}
                  </option>
                ))}
              </select>
            )}
          </div>

          {showTimeFilter && (
            <div className="filters">
              {TIME_FILTERS.map((f, i) => (
                <div className="filter-item" key={f.value}>
                  <button
                    className={timeRange === f.value ? "active" : ""}
                    onClick={() => onTimeChange(f.value)}
                  >
                    {f.label}
                  </button>
                  {i === 0 && <span className="v-separator" />}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminSubHeader;
